import { UIStateProps, uiState } from '../../atoms/uiAtom';

import Container from './Container';
import ErrorBanner from './ErrorBanner';
import { Fragment } from 'react';
import Header from './Header';
import Loader from './Loader';
import WarningBanner from './WarningBanner';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';

interface LayoutProps {
  children: JSX.Element;
}
export default function Layout({ children }: LayoutProps) {
  const [ui, setUiState] = useRecoilState<UIStateProps>(uiState);

  const location = useLocation();
  const handleCloseWarningBanner = () => {
    setUiState((prev) => ({ ...prev, hasWarning: null }));
  };

  return (
    <Fragment>
      <Header />
      <ErrorBanner className={classNames({ 'banner--visible': ui.hasError })}>
        {ui.hasError}
      </ErrorBanner>
      <WarningBanner
        className={classNames({
          'banner--visible': ui.hasWarning && location.pathname.includes(ui.hasWarning.route),
        })}
        onClose={handleCloseWarningBanner}
      >
        {ui.hasWarning?.message}
      </WarningBanner>

      <Container tag="main">{children}</Container>
      {ui.isFetching && <Loader hasBackdrop color="#a3117b" />}
    </Fragment>
  );
}
